
import { SyncProvider } from './../providers/syncProvider';
import { BLLMalKabul } from './../providers/bll/bll-nlsiparis';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { PagesProvider } from './../providers/pages-provider';
import { BllRememberAcc } from './../providers/bll/bll-remember-acc';
import { Camera } from '@ionic-native/camera';
import { DalProvider } from './../providers/dal/dal';
import { BarcodeScannerProvider } from './../providers/barcode-scanner-provider';
import { IndexedDBWrapper } from './../providers/indexeddb-wrapper';
import { GirisPage } from './../pages/giris/giris';
import { HttpModule } from '@angular/http';
import { Ortak } from './../providers/ortak';
import { Servis } from './../providers/servis';
import { BllOrtak } from './../providers/bll/bll-ortak';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { CalendarModule } from "ion2-calendar";
import { CariOdemePage } from '../pages/cari-odeme/cari-odeme';
import { CariStokSecimPage } from '../pages/cari-stok-secim/cari-stok-secim';
import { CariIslemPage } from '../pages/CariIslemleri/cari-islem/cari-islem';
import { DepoCikisIslemiPage } from '../pages/depo-cikis-islemi/depo-cikis-islemi';
import { GunlukGelenUrunlerPage } from '../pages/gunluk-gelen-urunler/gunluk-gelen-urunler';
import { MalkayitListePage } from '../pages/MalKayit/malkayit-liste/malkayit-liste';
import { RaporanasayfaPage } from '../pages/raporanasayfa/raporanasayfa';
import { StokHareketDetayPage } from '../pages/StokIslemleri/stok-hareket-detay/stok-hareket-detay';
import { StokeklePage } from '../pages/StokIslemleri/stokekle/stokekle';
import { StokhareketleriPage } from '../pages/StokIslemleri/stokhareketleri/stokhareketleri';
import { HareketdetayPage } from '../pages/CariIslemleri/hareketdetay/hareketdetay';
import { KasiyerBazliRaporPage } from '../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { EtiketbasPage } from '../pages/StokIslemleri/etiketbas/etiketbas';
import { EtiketlistesiPage } from '../pages/StokIslemleri/etiketlistesi/etiketlistesi';
import { SayimGirisiPage } from '../pages/StokIslemleri/sayim-girisi/sayim-girisi';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { YonetimAnaSayfaPage } from '../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { GelirgiderPage } from '../pages/Yonetim/gelirgider/gelirgider';
import { GelirgidereklePage } from '../pages/Yonetim/gelirgider/gelirgiderekle/gelirgiderekle';
import { DepoKayitlariPage } from '../pages/UreticiIslemleri/depo-kayitlari/depo-kayitlari';
import { KullaniciListePage } from '../pages/Yonetim/kullanici-liste/kullanici-liste';
import { KullanicieklePage } from '../pages/Yonetim/kullaniciekle/kullaniciekle';
import { PersonelEkleGuncellePage } from '../pages/CariIslemleri/personel-ekle-guncelle/personel-ekle-guncelle';
import { PersonelListesiPage } from '../pages/CariIslemleri/personel-listesi/personel-listesi';
import { PersonelPage } from '../pages/Yonetim/personel/personel';
import { CarilerPage } from '../pages/CariIslemleri/cariler/cariler';
import { ProgramAyarlariPage } from '../pages/program-ayarlari/program-ayarlari';
import { CarieklePage } from '../pages/CariIslemleri/cariekle/cariekle';
import { CarismsgonderPage } from '../pages/CariIslemleri/carismsgonder/carismsgonder';
import { CarisecmodalPage } from '../pages/CariIslemleri/carisecmodal/carisecmodal';
import { CariTahsilatPage } from '../pages/CariIslemleri/cari-tahsilat/cari-tahsilat';
import { CariborcdekontPage } from '../pages/CariIslemleri/cariborcdekont/cariborcdekont';
import { CarialacakdekontPage } from '../pages/CariIslemleri/carialacakdekont/carialacakdekont';
import { CariHareketleriPage } from '../pages/CariIslemleri/cari-hareketleri/cari-hareketleri';
import { ReportsPage } from '../pages/Raporlars/reports/reports';
import { CarisecPage } from '../pages/faturaislemleri/carisec/carisec';
import { SatispagePage } from '../pages/Muhasebe/Satis/satispage/satispage';
import { UreticiBilgisiPage } from '../pages/UreticiIslemleri/uretici-bilgisi/uretici-bilgisi';
import { UrunAktarModalPage } from '../pages/MalKayit/urun-aktar-modal/urun-aktar-modal';
import { MalgiriseklePage } from '../pages/MalKayit/malgirisekle/malgirisekle';
import { CariEkstreRaporuPage } from '../pages/cari-ekstre-raporu/cari-ekstre-raporu';
import { ToptancilarListesiPage } from '../pages/toptancilar-listesi/toptancilar-listesi';




@NgModule({
  declarations: [
    MyApp,
    HomePage,
    GirisPage,
  CariOdemePage,
  CariStokSecimPage,
  CariIslemPage,
  DepoCikisIslemiPage,
  GunlukGelenUrunlerPage,
  MalkayitListePage,
  RaporanasayfaPage,
  StokHareketDetayPage,
  StokeklePage,
  StokhareketleriPage,
  HareketdetayPage,
  KasiyerBazliRaporPage,
  EtiketbasPage,
  EtiketlistesiPage,
  SayimGirisiPage,
  StoklarPage,
  YonetimAnaSayfaPage,
  GelirgiderPage,
  GelirgidereklePage,
  DepoKayitlariPage,
  KullaniciListePage,
  KullanicieklePage,
  PersonelEkleGuncellePage,
  PersonelListesiPage,
  PersonelPage,
  CarilerPage,
  ProgramAyarlariPage,
  CarieklePage,
  CarismsgonderPage,
  CarisecmodalPage,
  CariTahsilatPage,
  CariborcdekontPage,
  CarialacakdekontPage,
  CariHareketleriPage,
  ReportsPage,
  CarisecPage,
  SatispagePage,
  UreticiBilgisiPage,
  UrunAktarModalPage,
  MalgiriseklePage,
  CariEkstreRaporuPage,
  ToptancilarListesiPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: 'Geri'
        }
      }
    }),

    CalendarModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    GirisPage,
   CariOdemePage,
  CariStokSecimPage,
  CariIslemPage,
  DepoCikisIslemiPage,
  GunlukGelenUrunlerPage,
  MalkayitListePage,
  RaporanasayfaPage,
  StokHareketDetayPage,
  StokeklePage,
  StokhareketleriPage,
  HareketdetayPage,
  KasiyerBazliRaporPage,
  EtiketbasPage,
  EtiketlistesiPage,
  SayimGirisiPage,
  StoklarPage,
  YonetimAnaSayfaPage,
  GelirgiderPage,
  GelirgidereklePage,
  DepoKayitlariPage,
  KullaniciListePage,
  KullanicieklePage,
  PersonelEkleGuncellePage,
  PersonelListesiPage,
  PersonelPage,
  CarilerPage,
  ProgramAyarlariPage,
  CarieklePage,
  CarismsgonderPage,
  CarisecmodalPage,
  CariTahsilatPage,
  CariborcdekontPage,
  CarialacakdekontPage,
  CariHareketleriPage,
  ReportsPage,
  CarisecPage,
  SatispagePage,
  UreticiBilgisiPage,
  UrunAktarModalPage,
  MalgiriseklePage,
  CariEkstreRaporuPage,
ToptancilarListesiPage,
],
  providers: [
    StatusBar,
    SplashScreen,
    BllOrtak,
    Servis,
    BarcodeScanner,
    BLLMalKabul,
    SyncProvider,
    Ortak,
    BllRememberAcc,
    IndexedDBWrapper,
    { provide: ErrorHandler, useClass: IonicErrorHandler }, Ortak, Servis, AndroidFullScreen, BllOrtak, PagesProvider, Camera, BarcodeScannerProvider, DalProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts